import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
//api
import { deleteAuthor } from 'api/products';
import { getAllAuthors } from 'api/pathForHook/products';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Title from 'components/backoffice/texts/title';
import Button from 'components/backoffice/buttonCustom';
import AutorModal from './modals/AutorModal';
import SearchTable from 'components/backoffice/table/SearchTable';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import { usePermissions } from 'components/backoffice/PermissionsContext';

const Authors = () => {
  const userPermissions = usePermissions();
  const [listNames, setListNames] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [typeAction, setTypeAction] = useState('create');
  const [autor, setAutor] = useState({});
  const [page, setPage] = useState(1);
  const [responseInfo, setResponseInfo] = useState({})
  const { setTitle } = useOutletContext()

  const { fetchData, stateData, loading } = useHandleSearch();

  const { t } = useTranslation(['backoffice']);

  const colsAuthors = ['ID', t('name'), t('actions')];

  const getListAuthors = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        nombre_autor: inputValue
      }
      await fetchData(getAllAuthors(), payload);
    } catch (error) {
      console.error(error);
    }
  }


  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListNames(results);
      setResponseInfo({ errors, totalPages, noResults })
    } else {
      setListNames(null);
      setResponseInfo({ errors })
    }
  }, [stateData])

  useEffect(() => {
    setTitle(t('autores'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    if (page > 1 && inputValue !== '') {
      setPage(1)
    }
  }, [inputValue])

  useEffect(() => {
    getListAuthors();
  }, [page, inputValue]);

  const modalUpdate = (object) => {
    setShowModal(true);
    setTypeAction('edit');
    setAutor(object);
  };

  const modalCreate = () => {
    setShowModal(true);
    setTypeAction('create');
    setAutor({});
  };

  const onDelete = async () => {
    const { status } = await deleteAuthor(autor.id);
    if (status === 204) {
      toast.success(t('eliminadocorrectamente'));
      setInputValue('');
      getListAuthors();
      setShowDeleteModal(false);
    }
  };

  const openMOdalDelete = (object) => {
    setShowDeleteModal(true);
    setAutor(object);
  };

  const handleClear = () => {
    setInputValue('');
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, totalPages: responseInfo?.totalPages }));
  };

  const onSuccess = () => {
    setPage(1);
    getListAuthors();
  };

  return (
    <div>
      <Title text={t('autores')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={5} xs={12} className="d-flex text-start">
          <SearchTable
            value={inputValue}
            handleSearch={setInputValue}
            handleClear={handleClear}
            handleKeyDown={true}
            placeholder={t('searchbyname')}
          />
        </Col>
        <Col md={7} xs={12} className="text-end mt-3 mt-md-0">
          {userPermissions.includes('autor.__add') && (
            <Button color={'primary'} onClick={modalCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <CustomTable
        cols={colsAuthors}
        noResults={responseInfo?.noResults}
        isLoading={loading}
        page={page}
        changePage={setPage}
        totalPages={responseInfo?.totalPages}
      >
        {listNames &&
          listNames?.map((listName) => {
            return (
              <tr key={listName.id}>
                <td>#{listName.id}</td>
                <td>{listName.nombre_autor}</td>
                <td className="item-dropdown text-end">
                  <DropdownIcons
                    idItem={listName.id}
                    handleDelete={
                      userPermissions.includes('autor.__delete')
                      && (() => openMOdalDelete(listName))
                    }
                    handleEdit={
                      userPermissions.includes('autor.__modify')
                      && (() => modalUpdate(listName))
                    }
                  />
                </td>
              </tr>
            );
          })}
      </CustomTable>
      <AutorModal
        onUpdateTable={onSuccess}
        show={showModal}
        setShow={setShowModal}
        type={typeAction}
        object={autor}
      />
      <DeleteModalCustom
        name={autor?.nombre_autor}
        openModal={showDeleteModal}
        setOpenModal={setShowDeleteModal}
        handleDelete={onDelete}
        deleteTitle={t('deleteauthor')}
        beforeTitle={t('autores')}
      />
    </div>
  );
};

export default Authors;
